import router from '@/router';
import api from '../../api/index';
import {COURSE_TYPES} from '@/modules/Knowledge_check/Knowledge_check';

export default {
  namespaced: true,
  state     : {
    questions       : [],
    current_question: 0,
    answers         : {
      assignedTestId: -1,
      answers       : {},
    },
  },
  getters: {
    question_list       : ({questions}) => questions,
    get_current_question: ({current_question}) => current_question,
    get_answers         : ({answers}) => answers.answers,
  },
  mutations: {
    SET_COURSE_QUESTIONS(state, questions) {
      state.questions = questions;
    },
    SET_CURRENT_QUESTION(state, questionIndex) {
      state.current_question = questionIndex;
    },
    SET_COURSE_ID_AT_ANSWERS(state, courseId) {
      state.answers.assignedTestId = courseId;
    },
    SET_QUESTION_ANSWER(state, {questionId, answer}) {
      state.answers.answers[questionId] = answer;
    },
    CLEAR_ANSWERS(state) {
      state.answers = {
        assignedTestId: -1,
        answers       : {},
      };
    },
  },
  actions: {
    async check_answer({state, rootGetters, commit}) {
      console.log(111);
      try {
        await api.tests.post_check_answers(state.answers);
        router.push({name: 'knowledge_check'});
        commit(
            'knowledge_check/SELECT_FILTER',
            rootGetters['knowledge_check/filters'].findIndex((filter) => filter.name === COURSE_TYPES.COMPLETE),
            {root: true}
        );
        commit('CLEAR_ANSWERS');
      } catch (e) {
        if (e.message.indexOf('401') !== -1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async get_course_questions({commit}, courseId) {
      try {
        const questionsResponse = await api.tests.get_questions(courseId);
        commit('SET_COURSE_QUESTIONS', questionsResponse.data);
      } catch (e) {
        if (e.message.indexOf('401') !== -1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
